module.exports = __webpack_public_path__ + "static/media/nodejs-light.b04c465b.png";